import { define } from '../../define.js';
import { Slider } from './slider.js';
export * from './slider.js';
define('slider', Slider);
